import styled from 'react-emotion';
import isPropValid from '@emotion/is-prop-valid';

export const ZoomWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

export const ZoomTriggerWrapper = styled('div', {
  shouldForwardProp: prop => (isPropValid(prop) || prop == 'touch-action' ? prop : false)
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  user-select: none;
  touch-action: none;
`;
